import {
  BgmEligibilityProto_Value,
  ScaleEligibilityProto_Value,
} from "@noom/noom-contracts/noom_contracts/backend/enrollment/b2b/shared";
import { UpfrontEligibilityEnforcementProto_Value } from "@noom/noom-contracts/noom_contracts/backend/enrollment/deployments/upfront_eligibility_enforcement";
import { EligibilitySourceProto_Value } from "@noom/noom-contracts/noom_contracts/backend/partner/model/shared";
import {
  CandidateMatchProto,
  CheckEligibilityResponseProto,
} from "@noom/noom-contracts/noom_contracts/backend/partner/service/partner_eligibility_service";

import type { ProgramOffering } from "@/constants";

import type { Address } from "./Address";

export type EligibilityEnforcementType = Exclude<
  UpfrontEligibilityEnforcementProto_Value,
  "UNKNOWN" | "UNRECOGNIZED"
>;

export type EligibilitySource = Exclude<
  EligibilitySourceProto_Value,
  "UNKNOWN" | "UNRECOGNIZED"
>;

export type BgmEligibility = Exclude<
  BgmEligibilityProto_Value,
  "UNKNOWN" | "UNRECOGNIZED"
>;

export enum EligibilityReason {
  ELIGIBLE = "ELIGIBLE",
  EXISTING_ACCOUNT = "EXISTING_ACCOUNT",
  INELIGIBLE = "INELIGIBLE",
  NOT_IN_LATEST_FILE = "NOT_IN_LATEST_FILE",
  PRIOR_TO_EFFECTIVE_DATE = "PRIOR_TO_EFFECTIVE_DATE",
  API_ERROR = "API_ERROR",
  MULTIPLE_MATCHES = "MULTIPLE_MATCHES",
}

export type EligibilityVerificationProperties = {
  email?: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  participantId?: string;
  eligibilityId?: string;
  policyId?: string;
};

export type EligibilityExtras = Partial<{
  address: Address;
  phoneNumber: string;
  policyId: string;
}>;

export type EligibilityResponse = CheckEligibilityResponseProto;

export type EligibilityCandidateMatch = CandidateMatchProto;

export type EligibilityInfo = Partial<{
  dob: Date;
  effectiveDate: Date;
  eligibilityId: string;
  eligiblePrograms: ProgramOffering[];
  email: string;
  employeeId: string;
  firstName: string;
  lastName: string;
  segmentId: string;
  segmentName: string;
  scaleEligible: ScaleEligibilityProto_Value;
}> &
  EligibilityExtras;
